import { useBadgingTranslation } from '../../../../ui/hooks';
import { getSettings } from '@juvare/platform-sdk-react/ui/features/editable-settings';
import { useSelector } from 'react-redux';
export function useBadgeHistoryTableColumns() {
    const settings = useSelector(getSettings);
    const { t } = useBadgingTranslation();
    const columns = [
        {
            headerLabel: t('badges.badgeDetails.badgeHistoryTable.headers.action'),
            cellFunction: (row) => {
                const { accountBadgeNames } = row.columns;
                return t(`badges.badgeDetails.badgeHistoryTable.actions.${row.columns.action}`, {
                    count: accountBadgeNames.length,
                    name: accountBadgeNames.length === 1 ? accountBadgeNames[0] : '',
                });
            },
            sortKey: 'action',
            tableCellSx: { verticalAlign: 'top' },
        },
        {
            headerLabel: t('badges.badgeDetails.badgeHistoryTable.headers.note'),
            cellFunction: (row) => { var _a; return (_a = row.columns.note) !== null && _a !== void 0 ? _a : '-'; },
            sortKey: 'note',
            tableCellSx: { verticalAlign: 'top', maxWidth: 260 },
        },
        {
            headerLabel: t('badges.badgeDetails.badgeHistoryTable.headers.dateAndTime'),
            cellFunction: (row) => row.columns.createdAt && Number.isInteger(row.columns.createdAt) ? new Date(row.columns.createdAt).toLocaleString() : '',
            sortKey: 'createdAt',
            tableCellSx: { verticalAlign: 'top' },
        },
        {
            headerLabel: t('badges.badgeDetails.badgeHistoryTable.headers.updateBy'),
            cellFunction: (row) => row.columns.createdByEmail,
            sortKey: 'createdByEmail',
            tableCellSx: { verticalAlign: 'top' },
        },
        {
            headerLabel: t('badges.badgeDetails.badgeHistoryTable.headers.role'),
            cellFunction: (row) => settings.systemRoleMap[row.columns.createdByRole].label,
            sortKey: 'createdByRole',
            tableCellSx: { verticalAlign: 'top' },
        },
    ];
    return columns;
}
